import { User } from '@supabase/supabase-js'


const waitForFeedbaskWidget = (timeout = 5000): Promise<boolean> => {
	return new Promise((resolve) => {
		if (window.feedbask && typeof window.feedbask.identify === 'function') {
			resolve(true)
			return
		}

		let timeoutId: NodeJS.Timeout
		let attempts = 0
		const maxAttempts = timeout / 100

		const checkWidget = () => {
			attempts++
			
			if (window.feedbask && typeof window.feedbask.identify === 'function') {
				clearTimeout(timeoutId)
				resolve(true)
				return
			}

			if (attempts >= maxAttempts) {
					clearTimeout(timeoutId)
				resolve(false)
				return
			}

			timeoutId = setTimeout(checkWidget, 100)
		}

		checkWidget()
	})
}

export interface TeamInfo {
	name: string
	plan_id: string
	created_at: string
}


export const identifyFeedbaskUser = async (user: User, teamInfo?: TeamInfo): Promise<void> => {
	try {
		const isReady = await waitForFeedbaskWidget()
		if (!isReady) {
			return
		}

		const userId = user.id
		const userName = user.user_metadata?.full_name || null
		const userEmail = user.email || null

		const userProperties: Record<string, any> = {}
		
		if (userName) {
			userProperties.name = userName
		}
		
		if (userEmail) {
			userProperties.email = userEmail
		}

		if (teamInfo) {
			userProperties.plan = teamInfo.plan_id
			userProperties.team_name = teamInfo.name
		}

		window.feedbask!.identify({
			userId,
			...userProperties
		})
		
		currentIdentifiedUserId = userId
		
	} catch (error) {
		}
}

export const unidentifyFeedbaskUser = async (): Promise<void> => {
	try {
		const isReady = await waitForFeedbaskWidget(1000)
		if (!isReady) {
			return
		}

		window.feedbask!.unidentify()
		
		currentIdentifiedUserId = null
		
	} catch (error) {
		}
}

export const getFeedbaskIdentifiedUser = async (): Promise<{ externalUserId: string; userProperties: Record<string, any> } | null> => {
	try {
		const isReady = await waitForFeedbaskWidget(1000)
		if (!isReady) {
			return null
		}

		return window.feedbask!.getIdentifiedUser()
	} catch (error) {
			return null
	}
}

let currentIdentifiedUserId: string | null = null

export const getFeedbaskIdentifiedUserId = (): string | null => {
	return currentIdentifiedUserId
} 